import { Button, ButtonProps } from "@outschool/backpack";
// This file is not yet translated.
/* eslint-disable i18next/no-literal-string */
import { AuthTrigger, useLoginFlowContext } from "@outschool/ui-auth";
import React from "react";

export default function JoinAndWelcomeButton(
  props: ButtonProps & { newUrl?: string; shouldNavigateOverwrite?: boolean }
) {
  const { enterLoginFlow } = useLoginFlowContext();
  const { shouldNavigateOverwrite, newUrl, ...rest } = props;

  return (
    <Button
      variant="contained"
      {...rest}
      onClick={(e: any) => {
        enterLoginFlow({
          authTrigger: AuthTrigger.JOIN_OUTSCHOOL,
          newUrl,
          shouldNavigateOverwrite
        });

        props.onClick?.(e);
      }}
    />
  );
}
